// extracted by mini-css-extract-plugin
export default {"button":"AnotherCardButton_button__Jdvz8"};